import { Box } from "@mui/material";
import bannerSrc from "@arelia-assets/hq-banner.png";
import ImageHeader from "@arelia-components/layout/ImageHeader";
import theme from "src/theme";
import HqDashboardPresenter from "./HqDashboardPresenter";

export default function HqDashboardContainer() {
  return (
    <Box
      bgcolor={theme.palette.background.default}
      flexGrow={1}
      height={1}
      display="flex"
      flexDirection="column"
      gap={"34px"}
      sx={{
        overflowY: "auto",
      }}
    >
      <ImageHeader
        title="Dashboard"
        backgroundUrl={bannerSrc}
        dashboard
      ></ImageHeader>
      <Box p={5} pt={2}>
        <HqDashboardPresenter></HqDashboardPresenter>
      </Box>
    </Box>
  );
}
